import emitter from "../core/emitter";
import Middleware from "../core/middleware";
import pinia from "../core/pinia";
import { useHistoryStore, useModalStore, useStepsStore, useVdpTableStore } from "../stores";
import { E_STEP_NAME } from "../types/components.enums";
import { E_EDITOR_CUSTOM_EVENT } from "../types/custom-events.enums";
import { E_MIDDLEWARE_STEPS } from "../types/middlewares.types";
import { E_MODAL } from "../types/modals.enum";
import { E_TO_STEP_CUSTOM_EVENT } from "../types/steps.types";


const stepsMiddleware = new Middleware();

async function toVdp(to: string) {
  emitter.emit(E_TO_STEP_CUSTOM_EVENT.LOAD_START, to);
  
  const modalStore = useModalStore(pinia);
  const vdpTableStore = useVdpTableStore(pinia);
  const historyStore = useHistoryStore(pinia);
  const promise: Promise<boolean> = new Promise(async (resolve, reject) => {
    if (to != 'vdp-table') return resolve(true);

    if (historyStore.getLastItem?.data.stepName === E_STEP_NAME.EDITOR) {
      emitter.emit(E_EDITOR_CUSTOM_EVENT.SAVE_DESIGN);
      await saveDesignSuccess();
    }

    const hasVdpVariables: boolean = vdpTableStore.getDataset?.some((dt) => !!dt.columns.length) || false;

    if (!hasVdpVariables) {
      openModal();
    }

    function saveDesignSuccess() {
      return new Promise((res, rej) => {
        try {
          emitter.on(E_EDITOR_CUSTOM_EVENT.SAVE_DESIGN_SUCCESS, (stateId: any) => {
            emitter.off(E_EDITOR_CUSTOM_EVENT.SAVE_DESIGN_SUCCESS);
            res(stateId as string);
            return stateId as string;
          });
        } catch (error) {
          rej(error);
        }
      });
    }

    function openModal() {
      const modalIds = modalStore.getModalIdsByName(E_MODAL.VDP_VALIDATE_MODAL);
      if (!modalIds.length) {
        const message = `Modal '${E_MODAL.VDP_VALIDATE_MODAL}' not found'`;
        reject(message);
        throw new Error(message);
      }
      modalStore.show(modalIds[0]);
    }

    resolve(hasVdpVariables);
  });

  return promise.then((result) => {
    const stepsStore = useStepsStore(pinia);
    if (result) {
      stepsStore.setCurrentStep(to);
      emitter.emit(E_MIDDLEWARE_STEPS.RESULT, true);
    } else {
      emitter.emit(E_MIDDLEWARE_STEPS.RESULT, false);
      console.warn('[Middleware] I warn you about changes that have not occurred.');
    }
  }).finally(() => {
    emitter.emit(E_TO_STEP_CUSTOM_EVENT.LOAD_END, to);
  }).catch((ex) => {
    emitter.emit(E_MIDDLEWARE_STEPS.RESULT, false);
    console.error(ex);
  });
};

stepsMiddleware.register(toVdp);

export default stepsMiddleware;